module.exports = __webpack_public_path__ + "img/main-bg.c9cc9129.jpg";